import { IColumns } from '../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'login-history',
  columns: [
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
      },
    },
    {
      id: 'duration',
      label: 'DURATION',
    },
    {
      id: 'location',
      label: 'LOCATION',
    },
    {
      id: 'ip',
      label: 'IP ADDRESS',
    },
  ],
}
/*
export const stateData = [
  { id: 1, date: '09-12-2021', duration: '18:43', location: 'United States', ipAddress: '197.112.135.39' },
  { id: 2, date: '09-12-2021', duration: '01:55', location: 'Germany', ipAddress: '100.33.8.44' },
  { id: 3, date: '09-12-2021', duration: '09:53', location: 'Cyprus', ipAddress: '107.96.198.227' },
]

export const meta = {
  totalItems: 4,
  itemCount: 4,
  itemsPerPage: 3,
  totalPages: 2,
  currentPage: 1,
}
*/
